<template>
  <div class="subscriptions-list">
    <subscription-item
        v-for="item of subscriptions"
        :key="item.id"
        :subscription="item"
        :serviceTypes="serviceTypes"
    />

  </div>
</template>

<script>
import SubscriptionItem from "./SubscriptionItem"

export default {
  name: "SubscriptionList",
  props: {
    subscriptions: {
      require: true
    },
    serviceTypes: {
      require: true
    },
    pagination: {
      require: true
    },
  },
  data: () => {
    return {

    }
  },
  components: {SubscriptionItem},
  computed: {},
  mounted() {
    // this.loadData()
  },
  methods: {
    goPage (page) {
      console.log('Доделать тут')
      this.$emit('goPage', page)

    }


  }
}
</script>

<style scoped lang="scss">

.pagination {
  margin-top: 16px!important;
}



</style>
